import styled from 'styled-components';

import vars from 'variables';

const Root = styled.footer`
  background: rgb(13, 15, 35);

  ${vars.desktop.mediaQuery} {
    /* styling */
  }

  ${vars.mobile.mediaQuery} {
    /* styling */
  }
`;

export { Root };
